import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Field, FormikErrors, FormikValues } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import {
  proceedToNextFormStep,
  goBack,
} from "../../../actions/diversityFormActions";
import RadioButton from "../../shared/publicForms/RadioButton";
import TextField from "../../shared/publicForms/TextField";
import {
  StepWrapper,
  Title,
  RadioButtonGroupWrapper,
  RadioButtonGroup,
  BackButton,
  ButtonsWrapper,
  Button,
  DisabledButton,
} from "../styles/diversity-form-styles";

export interface IOrientationProps {
  values: {
    orientation?: null | string;
  };
  errors: FormikErrors<FormikValues>;
  setFieldValue: (
    field: string,
    value: unknown,
    shouldValidate: boolean
  ) => void;
  proceedToNextFormStepAction: typeof proceedToNextFormStep;
  goBackAction: typeof goBack;
}

export const Orientation: FunctionComponent<IOrientationProps> = ({
  values,
  errors,
  proceedToNextFormStepAction,
  goBackAction,
  setFieldValue,
}) => {
  const options = [
    null,
    "Bisexual",
    "Gay man",
    "Gay woman/lesbian",
    "Heterosexual",
    "Prefer not to say",
  ];

  return (
    <StepWrapper data-test-id="orientation-step" formStep>
      <Title data-test-id="title">
        How would you describe your sexual orientation?
      </Title>
      <RadioButtonGroupWrapper
        role="group"
        aria-labelledby="orientation-radio-group"
      >
        <RadioButtonGroup width={220}>
          <Field
            name="orientation"
            type="radio"
            aria-label="Bisexual"
            label="Bisexual"
            value="Bisexual"
            as={RadioButton}
          />
          <Field
            name="orientation"
            type="radio"
            aria-label="Gay man"
            label="Gay man"
            value="Gay man"
            as={RadioButton}
          />
          <Field
            name="orientation"
            type="radio"
            aria-label="Gay woman/lesbian"
            label="Gay woman/lesbian"
            value="Gay woman/lesbian"
            as={RadioButton}
          />
          {!options.includes(values.orientation) && (
            <Field
              name="orientation"
              type="radio"
              aria-label="Prefer not to say"
              label="Prefer not to say"
              value="Prefer not to say"
              as={RadioButton}
            />
          )}
        </RadioButtonGroup>
        <RadioButtonGroup width={220}>
          <Field
            name="orientation"
            type="radio"
            aria-label="Heterosexual"
            label="Heterosexual"
            value="Heterosexual"
            as={RadioButton}
          />
          <Field
            name="orientation"
            type="radio"
            aria-label="Other"
            label="Other"
            value="Other"
            onChange={() => setFieldValue("orientation", "", true)}
            checked={!options.includes(values.orientation)}
            as={RadioButton}
          />
          {!options.includes(values.orientation) && (
            <Field
              name="orientation"
              type="text"
              aria-label={values.orientation}
              placeholder="Please specify"
              as={TextField}
            />
          )}
          {options.includes(values.orientation) && (
            <Field
              name="orientation"
              type="radio"
              aria-label="Prefer not to say"
              label="Prefer not to say"
              value="Prefer not to say"
              as={RadioButton}
            />
          )}
        </RadioButtonGroup>
      </RadioButtonGroupWrapper>
      <ButtonsWrapper>
        <BackButton type="button" onClick={goBackAction}>
          <FontAwesomeIcon icon={faChevronLeft} />
          back
        </BackButton>
        {values.orientation && !errors.orientation ? (
          <Button
            type="button"
            onClick={proceedToNextFormStepAction}
            data-test-id="next-button"
          >
            Next
          </Button>
        ) : (
          <DisabledButton type="button">Next</DisabledButton>
        )}
      </ButtonsWrapper>
    </StepWrapper>
  );
};

Orientation.propTypes = {
  values: PropTypes.shape({
    orientation: PropTypes.string,
  }).isRequired,
  errors: PropTypes.shape({
    orientation: PropTypes.string,
  }).isRequired,
  proceedToNextFormStepAction: PropTypes.func.isRequired,
  goBackAction: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

export default connect(null, {
  proceedToNextFormStepAction: proceedToNextFormStep,
  goBackAction: goBack,
})(Orientation);
